import React, { FC, useEffect } from 'react';

interface ImpressionProps {
  children: JSX.Element | JSX.Element[];
  onImpression: () => void;
  isVisible: boolean;
}

export const ImpressionWrapper: FC<ImpressionProps> = ({
  children,
  onImpression,
  isVisible,
}: ImpressionProps) => {
  useEffect(() => {
    if (isVisible) {
      onImpression();
    }
  });

  return <>{children}</>;
};
